import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    const textarea = this.hasTextareaTarget ? this.textareaTarget : this.element.querySelector("textarea")
    if (textarea) {
      this.setupTextarea(textarea)
    }
  }

  setupTextarea(textarea) {
    this.adjustHeight(textarea)
    textarea.addEventListener("input", () => this.adjustHeight(textarea))
  }

  adjustHeight(textarea) {
    textarea.style.height = "auto"
    textarea.style.height = `${textarea.scrollHeight}px`
  }
}

